import { hasNativeMainButton, useMainButton } from '@/hooks/useMainButton';

interface Props {
  text: string;
  onClick: () => void;
  enabled?: boolean;
  loading?: boolean;
  visible?: boolean;
}

/** Telegram'da — native MainButton; brauzerda (dev) — pastki qotirilgan tugma. */
export function MainAction({
  text,
  onClick,
  enabled = true,
  loading = false,
  visible = true,
}: Props) {
  useMainButton(text, onClick, { enabled, loading, visible });
  if (hasNativeMainButton() || !visible) return null;
  return (
    <div className="fixed inset-x-0 bottom-0 z-20 bg-gradient-to-t from-bg via-bg/90 to-transparent p-3 pt-6 pb-[max(12px,env(safe-area-inset-bottom))]">
      <button
        type="button"
        disabled={!enabled || loading}
        onClick={onClick}
        className="btn-primary w-full"
      >
        {loading ? '…' : text}
      </button>
    </div>
  );
}
